export default {
  // 5-4
  GET_BBSLOCATION_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    const all = {
      description: "全部",
      e_Description: "ALL",
      location_Id: "ALL",
    };
    data.unshift(all);
    state.bbsLoc_list = data;
  },
  GET_BBSHISTORY_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.comments = `${e.emp_Dept_Full_Name}-${e.emp_Name}`;
      e.valid_Date = `${e.valid_Beg_Date}~${e.valid_End_Date}`;
      e.bbs_Info = `${
        e.bbs_Cat === "REGULAR" ? "一般公告" : "各廠區施工規範"
      }/${e.description || ""}`;
    });
    state.bbsHistory_all = data;
    state.bbsHistory_allList = state.bbsHistory_all.slice(0, 10);
  },
  GET_BBSHISTORY_DETAIL(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    state.bbsHistory_detail = data;
  },
};
